var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon500(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5529 46.2912L34.6826 46.0198L35.1877 41.9121C35.9108 36.0304 38.6998 30.5969 43.0571 26.5805C47.4145 22.5642 53.0568 20.2263 58.9778 19.9838C64.8989 19.7414 70.7135 21.61 75.3847 25.2566C77.9726 27.2769 80.1164 29.7702 81.7181 32.579C76.6395 32.2507 71.5204 32.7615 66.5704 34.1108C58.6845 36.2605 51.5092 40.4615 45.7751 46.2862C40.041 52.111 35.9529 59.3512 33.9271 67.2698C32.4411 73.0783 32.1037 79.0996 32.9106 84.9994L31.875 84.9994L31.8644 84.9994C26.8323 85.0102 21.9934 83.0627 18.3717 79.569C14.75 76.0754 12.6296 71.3098 12.4592 66.2806C12.2888 61.2514 14.0818 56.3532 17.4587 52.6224C20.8356 48.8917 25.5316 46.6211 30.5529 46.2912ZM107.5 78.7494C107.5 82.5249 106.756 86.2635 105.312 89.7516C103.867 93.2397 101.749 96.4091 99.0794 99.0788C96.4097 101.748 93.2403 103.866 89.7522 105.311C86.2641 106.756 82.5255 107.499 78.75 107.499C74.9745 107.499 71.236 106.756 67.7479 105.311C64.2598 103.866 61.0904 101.748 58.4207 99.0788C55.751 96.4091 53.6333 93.2397 52.1885 89.7516C50.7437 86.2635 50 82.5249 50 78.7494C50 71.1245 53.029 63.8118 58.4207 58.4201C63.8124 53.0284 71.1251 49.9994 78.75 49.9994C86.375 49.9994 93.6877 53.0284 99.0794 58.4201C104.471 63.8118 107.5 71.1245 107.5 78.7494ZM78.75 54.9994C76.4294 54.9994 74.2038 55.9213 72.5629 57.5622C70.9219 59.2032 70 61.4288 70 63.7494V78.7494C70 81.0701 70.9219 83.2957 72.5629 84.9366C72.8274 85.2011 73.1071 85.447 73.3999 85.6733C72.8641 86.0282 72.3612 86.4381 71.8999 86.8993C70.0832 88.7161 69.0625 91.1802 69.0625 93.7494C69.0625 96.3187 70.0832 98.7828 71.8999 100.6C73.7167 102.416 76.1808 103.437 78.75 103.437C81.3193 103.437 83.7834 102.416 85.6001 100.6C87.4169 98.7828 88.4375 96.3187 88.4375 93.7494C88.4375 91.1802 87.4169 88.7161 85.6001 86.8993C85.1389 86.4381 84.636 86.0282 84.1002 85.6733C84.393 85.447 84.6727 85.2011 84.9372 84.9366C86.5782 83.2957 87.5 81.0701 87.5 78.7494V63.7494C87.5 61.4288 86.5782 59.2032 84.9372 57.5622C83.2963 55.9213 81.0707 54.9994 78.75 54.9994Z",
    fill: "url(#paint0_linear_755_22119)",
    stroke: "url(#paint1_linear_755_22119)",
    strokeWidth: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_755_22119",
    x1: 59.9919,
    y1: 14.9629,
    x2: 91.3509,
    y2: 101.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_755_22119",
    x1: 59.9919,
    y1: 14.9629,
    x2: 91.3509,
    y2: 101.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8A011"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon500);
export default __webpack_public_path__ + "static/media/icon_500.423c6319b0e163d90525b6ac6cc2abb6.svg";
export { ForwardRef as ReactComponent };